import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { UsersService } from "./users.service"; // Adjust the path as necessary
import { SharedService } from "../../shared/shared.service";
import { MatDialog } from "@angular/material/dialog";
// import { UserEditPopupComponent } from "../userEditPopup/userEditPopup.component";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Subject } from "rxjs";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, AfterViewInit {

  fullUserList: any[] = [];
  mspinList: any[] = [];
  bucketurl = environment.bucketUrl;
  userForm: FormGroup;
  displayedColumns: string[] = [
    "SNo",
    "first_name",
    "role_id",
    "email",
    "username",
    "mobile",
    "outlets",
    "status"
    // "action",
  ];
  dataSource = new MatTableDataSource<any>([]);
  public searchInput = new FormControl("");
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public showPassword: boolean = false;

  isOutletRole: boolean = false;
  isAreaRole: boolean = false;
  isZoneRole: boolean = false;
  isRegionRole: boolean = false;
  isParentRole: boolean = false;
  ismspinRole: boolean = false;
  isSalesRole: boolean = false;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  out_letValue: any[] = [];
  roleValue: any[] = [];
  areaValue: any[] = [];
  zoneValue: any[] = [];
  regionValue: any[] = [];
  parent_dealerValue : any[] =[];
  productcategories: any[] = [];
  filteredProducts: any = [];
  filterProdCat: any = [];
  dropdownSettingsProCategory = {};

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private usersService: UsersService,
    private sharedService: SharedService,
    public dialog: MatDialog
  ) {
    this.userForm = this.fb.group({
      first_name: ["", Validators.required],
      last_name: [""],
      email: ["", [Validators.required, Validators.email]],
      username: ["", Validators.required],
      mobile: ["", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(10)]],
      role_id: ["", Validators.required],
      outlet_id: [""],
      area_id: [""],  // Added for Area
      zone_id: [""],  // Added for Zone
      region_id: [""], // Added for Region
      parent_dealer_id: [""], // Added for Parent Dealer
      mspin: [""],
      product_category: [[]],
      password: ["", Validators.required],
      alternate_mobile: [""],
    });
  }
  isLoading: Subject<boolean> = new Subject<boolean>();

  ngOnInit() {
    this.loadUserList();
    this.loadMSPINList();
    this.userForm.reset();

  // Listen for changes in the outlet selection
  setTimeout(()=>{
    this.initializeMastersData();
    this.onRoleChange();
  },2000)
 this.dropdownSettingsProCategory = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'category_id',
    textField: 'product_category',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  this.searchInput.valueChanges.subscribe(() => {
    this.applyFilter();
  });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  

  initializeMastersData() {
    const mastersSession = sessionStorage.getItem("masters");
    if (mastersSession) {
      try {
        const parsedResponse = JSON.parse(mastersSession);
        const masters = parsedResponse;
        console.log(masters);
        
  
        if (masters) {
          this.out_letValue = masters.outlets || [];  
          console.log(this.out_letValue); 
          console.log(this.out_letValue, 'this.out_letValue');
          this.roleValue = masters.roles || [];
          // this.mspinValue = masters.mspins || [];
          // console.log(this.roleValue, 'this.mspinValue')
          this.areaValue = masters.areas || [];
          this.zoneValue = masters.zones || [];
          this.regionValue = masters.regions || [];
          this.parent_dealerValue = masters.parentDealer || [];
          this.productcategories = masters.productCategory || [];
          console.log(this.parent_dealerValue, 'this.productcategories');
          
        } else {
          this.resetData();
        }
      } catch (error) {
        this.resetData();
      }
    } else {
      this.resetData();
    }
  }  

  resetData() {
    this.out_letValue = [];
    this.roleValue = [];
    this.areaValue = [];
    this.zoneValue = [];
    this.regionValue = [];
    this.parent_dealerValue = [];
    this.productcategories = [];
  }

  loadMSPINList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.usersService.getMspin().subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.isLoading.next(false);
          // Access the mspins array from the response
          this.mspinList = response.data.mspins || [];  // Ensure it's initialized to an array
          console.log(this.mspinList, 'this.mspinList');
        } else {
          this.isLoading.next(false);
        }
      },
      (error) => {
        this.isLoading.next(false);
        console.error('Error fetching MSPINs:', error); // Log error for debugging
      }
    );
  }
  

  onOutletChange(event: any) {
    const selectedOutletId = event.target.value;
  
    if (selectedOutletId) {
      // Filter mspinList based on the selected outlet_id
      this.filteredProducts = this.mspinList.filter(
        (mspin: any) => mspin.outlet_id === parseInt(selectedOutletId)
      );
      this.filterProdCat = this.productcategories.filter(
        (prodCat: any) => prodCat.outlet_id === parseInt(selectedOutletId)
      );
      console.log(this.filterProdCat);
    } else {
      this.filteredProducts = [];
      this.filterProdCat = [];
    }
  }
  


  onRoleChange() {
    this.userForm.get('role_id')?.valueChanges.subscribe(roleId => {
      // Determine role flags
      this.isOutletRole = (Number(roleId) === 5 || Number(roleId) === 4 || Number(roleId) === 3);
      this.ismspinRole = (Number(roleId) === 3)
      this.isAreaRole = (Number(roleId) === 8);
      this.isZoneRole = (Number(roleId) === 6);
      this.isRegionRole = (Number(roleId) === 7);
      this.isParentRole = (Number(roleId) === 9);
      this.isSalesRole = (Number(roleId) === 3);
  
      // Clear existing validators
      this.userForm.get('outlet_id')?.clearValidators();
      this.userForm.get('area_id')?.clearValidators();
      this.userForm.get('zone_id')?.clearValidators();
      this.userForm.get('region_id')?.clearValidators();
      this.userForm.get('parent_dealer_id')?.clearValidators();
  
      // Set validators based on role
      if (this.isOutletRole) {
        this.userForm.get('outlet_id')?.setValidators(Validators.required);
        this.userForm.get('area_id')?.setValue(null);
        this.userForm.get('zone_id')?.setValue(null);
        this.userForm.get('region_id')?.setValue(null);
        this.userForm.get('parent_dealer_id')?.setValue(null);
      }
      if (this.isAreaRole) {
        this.userForm.get('area_id')?.setValidators(Validators.required);
        this.userForm.get('outlet_id')?.setValue(null);
        this.userForm.get('zone_id')?.setValue(null);
        this.userForm.get('region_id')?.setValue(null);
        this.userForm.get('parent_dealer_id')?.setValue(null);
      }
      if (this.ismspinRole) {
        this.userForm.get('mspin')?.setValidators(Validators.required);
        this.userForm.get('outlet_id')?.setValidators(Validators.required);
        this.userForm.get('area_id')?.setValue(null);
        this.userForm.get('zone_id')?.setValue(null);
        this.userForm.get('region_id')?.setValue(null);
        this.userForm.get('parent_dealer_id')?.setValue(null);
      }
      if (this.isZoneRole) {
        this.userForm.get('zone_id')?.setValidators(Validators.required);
        this.userForm.get('outlet_id')?.setValue(null);
        this.userForm.get('area_id')?.setValue(null);
        this.userForm.get('region_id')?.setValue(null);
        this.userForm.get('parent_dealer_id')?.setValue(null);
      }
      if (this.isRegionRole) {
        this.userForm.get('region_id')?.setValidators(Validators.required);
        this.userForm.get('outlet_id')?.setValue(null);
        this.userForm.get('area_id')?.setValue(null);
        this.userForm.get('zone_id')?.setValue(null);
        this.userForm.get('parent_dealer_id')?.setValue(null);
      }
      if (this.isParentRole) {
        this.userForm.get('parent_dealer_id')?.setValidators(Validators.required);
        this.userForm.get('outlet_id')?.setValue(null);
        this.userForm.get('area_id')?.setValue(null);
        this.userForm.get('zone_id')?.setValue(null);
        this.userForm.get('region_id')?.setValue(null);
      }
      if(this.isSalesRole) {
        this.userForm.get('product_category')?.setValidators(Validators.required);
        this.userForm.get('mspin')?.setValidators(Validators.required);
        this.userForm.get('outlet_id')?.setValidators(Validators.required);
        this.userForm.get('area_id')?.setValue(null);
        this.userForm.get('zone_id')?.setValue(null);
        this.userForm.get('region_id')?.setValue(null);
        this.userForm.get('parent_dealer_id')?.setValue(null);
      }
  
      // Update validity
      this.userForm.get('product_category')?.updateValueAndValidity();
      this.userForm.get('mspin')?.updateValueAndValidity();
      this.userForm.get('outlet_id')?.updateValueAndValidity();
      this.userForm.get('area_id')?.updateValueAndValidity();
      this.userForm.get('zone_id')?.updateValueAndValidity();
      this.userForm.get('region_id')?.updateValueAndValidity();
      this.userForm.get('parent_dealer_id')?.updateValueAndValidity();
    });
  }
  
  
  
  

  get f() {
    return this.userForm.controls;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  add() {
    this.userForm.patchValue({
      role_id: '',
      outlet_id: '',
      area_id: '',
      zone_id: '',
      region_id: '',
      parent_dealer_id: '',
    })
    this.isCreate = true;
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.loadUserList();
  }

  createUser() {
    console.log('Creating user...');
    this.submitted = true;

    if (!this.userForm.valid) {
      Object.values(this.userForm.controls).forEach((control) => {
        control.markAsTouched();
      });
      return;
    }

    // const userData = this.userForm.value;
    const userData = {
      ...this.userForm.value,
      product_category: Array.isArray(this.userForm.value.product_category) 
        ? this.userForm.value.product_category.map((category: any) => category.category_id.toString())
        : []
    };
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.usersService.createUser(userData).subscribe(
      (response) => {
        if (response.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("User created successfully");
          this.isCreate = false;
          this.loadMSPINList();
          this.clearForm();
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(response.responseMessage);
        }
      },
      (error) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (error.status == 400) {
          this.toastr.error("Licence Code is already used");
        } else {
          this.toastr.error("Failed to create user");
        }
      }
    );
  }

  clearForm() {
    this.submitted = false;
    this.userForm.reset();
    this.userForm.patchValue({
      role_id: '',
      outlet_id: '',
      area_id: '',
      zone_id: '',
      region_id: '',
      parent_dealer_id: '',
    })
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  loadUserList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.usersService.getUserList().subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.isLoading.next(false);
          this.fullUserList = response.data;
          this.dataSource.data = this.fullUserList.map((user: any, index: any) => ({
            ...user,
            unId: index + 1,
          }));
          this.dataSource.paginator = this.paginator;
        } else {
          this.isLoading.next(false);
        }
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }
  

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    // Filter the user list based on search input
    this.dataSource.data = this.fullUserList.filter(user => {
      const firstName = user.first_name ? user.first_name.toLowerCase() : '';
      const lastName = user.last_name ? user.last_name.toLowerCase() : '';
      const username = user.username ? user.username.toLowerCase() : '';
      const email = user.email ? user.email.toLowerCase() : '';
      const mobile = user.mobile ? user.mobile : '';
  
      return (
        firstName.includes(filterValue) ||
        lastName.includes(filterValue) ||
        username.includes(filterValue) ||
        email.includes(filterValue) ||
        mobile.includes(filterValue)
      );
    });
  
    // Reset paginator to the first page
    this.paginator.pageIndex = 0;
    this.dataSource.paginator = this.paginator;
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter(); // Apply the filter to reset the list
  }  

  openEditPopup(user: any): void {
    // const dialogRef = this.dialog.open(UserEditPopupComponent, {
    //   width: "1000px",
    //   data: user,
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //     this.updateUser(user.id, result);
    //   }
    // });
  }

  updateUser(id: number, data: any): void {
    this.usersService.updateUser(id, data).subscribe(
      (response:any) => {
        if(response.responseCode == 200) {
          this.toastr.success(response.responseMessage);
          this.back();
        }else{
          this.toastr.error(response.responseMessage);
        }
       
      },
      (error) => {
        this.toastr.error("Failed to update user");
      }
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toLowerCaseCustom(value: string): string {
    return value.replace(/[A-Z]/g, (c) => String.fromCharCode(c.charCodeAt(0) + 32));
  }

  // onEmailChange(value: string): void {
  //   const lowercaseValue = value.toLowerCase(); // You can use a custom method here if needed
  //   if (lowercaseValue !== value) {
  //     // Only update the form control if the value needs to change
  //     this.userForm.get('email')?.setValue(lowercaseValue, { emitEvent: false });
  //   }
  // }
  onEmailChange(value: string | null): void {
    if (value !== null && value !== undefined) {
      const lowercaseValue = value.toLowerCase();
      if (lowercaseValue !== value) {
        // Only update the form control if the value needs to change
        this.userForm.get('email')?.setValue(lowercaseValue, { emitEvent: false });
      }
    }
  }
  
}
